import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  getFactoryCreditTopups,
  CreditTopupListQuery,
  CreditTopupListResponse,
} from "services/factoryCreditApi";

export const CREDIT_TOPUPS_QUERY_KEY = "factoryCreditTopups";

/** Datatable แท็บ "จัดการเครดิต" (มุมมองการสั่งซื้อ) — คนละ query key กับ useFactoryCreditTransactions
 * (ตาราง ledger ทั่วไปของแท็บ "ประวัติการใช้เครดิต") ไม่แชร์ cache กัน */
export const useFactoryCreditTopups = (
  params: CreditTopupListQuery,
  options?: { enabled?: boolean }
) =>
  useQuery<CreditTopupListResponse, Error>({
    queryKey: [CREDIT_TOPUPS_QUERY_KEY, params],
    queryFn: () => getFactoryCreditTopups(params),
    enabled: options?.enabled ?? true,
    placeholderData: keepPreviousData,
    refetchOnMount: "always",
  });
